/*
 * Pause looping decorative animations while they are off screen.
 *
 * A CSS animation keeps running whether or not its element is in view, and
 * the marquee strip and the hero's floating chips both loop forever. Pausing
 * rather than clearing preserves each animation's offset, so the strip
 * resumes mid-claim instead of snapping back to its first word.
 *
 * prefers-reduced-motion is handled in ge-tokens.css, which sets
 * `animation: none` on both selectors; setting play-state on an element with
 * no animation is a no-op, so the two need not know about each other.
 */
(() => {
  // Purely decorative, infinite, and safe to freeze mid-cycle.
  const SELECTOR = '.ge-marquee-track, .ge-hero__float';

  const targets = document.querySelectorAll(SELECTOR);
  if (!targets.length || !('IntersectionObserver' in window)) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        entry.target.style.animationPlayState = entry.isIntersecting ? 'running' : 'paused';
      });
    },
    // Resume just before the element is visible, so it is already moving.
    { rootMargin: '200px 0px' }
  );

  targets.forEach((el) => observer.observe(el));
})();
